<template>
  <div>
      <!-- page wrapper start -->
    <div class="pg-wrapper edit-account">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button @click="goBack()" class="button is-flex nav-back">
            <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back">
          </button>
            <h1 class="title has-text-black">Edit Account</h1>
        </div>
      </app-header>
      <main class="content-wrapper">
        <section class="section pt0">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-12-tablet is-9-desktop">
                <user-menu/>

                <div class="columns justify-content-center edit-from mt20">
                  <div class="column">
                    <div class="columns align-items-center justify-content-center is-2 is-variable is-mobile">
                      <div class="column flex-grow-0 ">
                        <div class="field-icon">
                          <img src="@/assets/img/icon-user2.svg" alt="user">
                          <p class="is-required">*</p>
                        </div>
                      </div>
                      <div class="column flex-grow-1">
                        <div class="field">
                          <!-- use is-animate class for animate placeholder effect -->
                            <!-- add is-filled class to input when input field is filled -->
                          <validation-provider name="First Name" ref="first_name" rules="required">
                            <template #default="{ errors }">
                              <div class="control is-animate">
                                <input
                                  class="input is-small is-filled"
                                  name="First Name"
                                  v-model="form.first_name"
                                  type="text"
                                />
                                <span class="validation-error">{{ errors[0] }}</span>
                                <span class="placeholder at-0">First Name</span>
                              </div>
                            </template>
                          </validation-provider>
                          <hr/>
                          <validation-provider name="Last Name" ref="last_name" rules="required">
                            <template #default="{ errors }">
                              <div class="control is-animate">
                                <input
                                  class="input is-small is-filled"
                                  name="Last Name"
                                  v-model="form.last_name"
                                  type="text"
                                />
                                <span class="validation-error">{{ errors[0] }}</span>
                                <span class="placeholder at-0">Last Name</span>
                              </div>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                    <div class="columns align-items-center justify-content-center is-2 is-variable is-mobile">
                      <div class="column flex-grow-0 ">
                        <div class="field-icon">
                          <img src="@/assets/img/icon-phone.svg" alt="user">
                        </div>
                      </div>
                      <div class="column flex-grow-1">
                        <div class="field ">
                          
                          <validation-provider name="Phone" ref="phone" rules="required|phone_number|numeric">
                            <template #default="{ errors }">
                              <div class="control is-animate">
                                <input
                                  onkeydown="javascript: return event.keyCode == 69 ||event.keyCode == 38 || event.keyCode == 40 || event.key==='.' ? false : true"
                                  class="input is-small is-filled hide-arrow"
                                  name="Phone"
                                  rules="required|phone_number|numeric"
                                  v-model="form.phone"
                                  type="number"
                                />
                                <span class="validation-error">{{ errors[0] }}</span>
                                <span class="placeholder at-0">Phone Number</span>
                              </div>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="columns align-items-center justify-content-center is-2 is-variable is-mobile">
                      <div class="column flex-grow-0 ">
                        <div class="field-icon">
                          <img src="@/assets/img/icon-email2.svg" alt="user">
                        </div>
                      </div>
                      <div class="column flex-grow-1">
                        <div class="field">
                          <validation-provider name="Email" ref="email" rules="required|email">
                            <template #default="{ errors }">
                              <div class="control is-animate">
                                <input
                                  class="input is-small is-filled"
                                  name="Email"
                                  :value="form.email"
                                  type="text"
                                  disabled
                                />
                                <span class="validation-error">{{ errors[0] }}</span>
                                <span class="placeholder at-0">Email</span>
                                <a class="edit-email" href="#" @click="openChangeEmailModal()"><i class="far fa-edit"></i> Edit</a>
                              </div>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="columns align-items-center justify-content-center is-2 is-variable is-mobile">
                      <div class="column flex-grow-0 ">
                        <div class="field-icon">
                          <img src="@/assets/img/icon-birthday.svg" alt="user">
                          <p  class="is-required">*</p>
                        </div>
                      </div>
                      <div class="column flex-grow-1">
                        <div class="field is-select">
                          <div class="control edit-account-dob select is-full-width pr-5">
                            <div class="columns is-multiline day-month-year-picker is-mobile justify-content-between">
                          
                              <div class="column">
                                <p>Day</p>  
                                <select class="has-select-option-dark" v-model="dob.day">
                                  <option value="" disabled>--</option>
                                  <option :value="day < 10 ? '0'+ day : day" v-for="day in 31" v-bind:key="day+ '_day'">{{ day < 10 ? '0'+ day : day }}</option>
                                </select>
                              </div>
                            <div class="column">
                              <p>Month</p>
                              <select class="has-select-option-dark" v-model="dob.month">
                                <option value="" disabled>--</option>
                                <option :value="month < 10 ? '0'+ month : month" v-for="month in 12" v-bind:key="month+ '_month'">{{ month < 10 ? '0'+ month : month }}</option>
                              </select>
                              </div>
                              <div class="column">
                                <p>Year</p>
                                <select v-model="dob.year" class="edit-account-year has-select-option-dark">
                                  <option value="" disabled>--</option>
                                  <option v-for="year in availableYears" v-bind:key="year+ '_year'">{{ year }}</option>
                                </select>
                              </div>
                              <span v-if="dobError" class="column validation-error is-12-mobile is-12-tablet" v-text="dobError"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="columns align-items-center justify-content-center is-2 is-variable is-mobile">
                      <div class="column flex-grow-0 ">
                        <div class="field-icon">
                          <img src="@/assets/img/icon-password.svg" alt="user">
                        </div>
                      </div>
                      <div class="column flex-grow-1">
                        <div class="level is-mobile">
                          <div class="level-left text-white">
                            ••••••••
                          </div>
                          <div class="level-right">
                            <a href="#" @click.prevent="changePassword()" class=" change-pass-text is-size-14">Change Password</a>
                          </div>
                        </div>
                      </div>
                    </div> -->

                  </div>
                </div>

              </div>
            </div>

            	
            <div class="columns justify-content-center is-6-tablet is-variable is-multiline mt50 pl30">
              <div class="column is-12-tablet is-9-desktop">
                <p class="is-size-14 "><span class="is-required mr10">*</span>Must match government-issued ID.</p>
                <h3 class="title is-size-15 mt50">Email Setting</h3>
                <div class="field mt20 mb30">
                  <input class="is-checkradio" v-model="casl" id="optin_check_myaccount" type="checkbox" value="1">
                  <label for="optin_check_myaccount" class="">Opt-in to receive marketing emails</label>
                </div>
                <button @click="updateProfile()" class="button bg-secondary text-white hover-opacity-7 is-medium mt30">
                  Save Changes
                </button>
              </div>
            </div>
           
          </div>
        </section>
      </main>
      <change-password></change-password>
      <change-email></change-email>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
// import ChangePassword from '@/Components/Pages/User/EditAccount/ChangePassword' old one we replaced;
import ChangePassword from '@/Components/Pages/User/EditAccount/ChangePasswordWithVerification';
import ChangeEmail from '@/Components/Pages/User/EditAccount/ChangeEmail';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { mapGetters, mapActions } from "vuex";
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { format } from "date-fns";
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import userMenu from '@/Components/Pages/User/Inc/UserNavMenu';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';


export default {
  components: {
    ChangePassword,
    ChangeEmail,
    Datepicker,
    Datetime,
    userMenu,
  },
  data() {
    return {
      modal: false,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        dob: '',
        marketing_notification: true,
        email_notification: true,
      },
      casl: false,
      dob:{
        day:'',
        month:'',
        year:'',
      },
      dobError: '',
    };
  },
  watch: {
    // watch if user hard code change business 
    // vg_businessProfile: {
    //   handler: function (val) {
    //     if(val.id){
    //       let res = UserApis.getUserBusinessCASl(val.id);
    //     }
    //   },
    //   deep: true
    // },
    'form.phone'(val){
      if(val){
      if(val.indexOf(".") != -1) {
        this.form.phone = val.replace(/\./g,"");
      }
      let newval = val.trim();
      if(val.length > 10){
        newval = newval.slice(0,10)
      } 
      this.form.phone = newval;
      }
    },
    'form.first_name'(val){
      this.form.first_name = val.trim();
    },
     'form.last_name'(val){
      this.form.last_name = val.trim();
    },
    '$store.getters.getLoggedInUser': {
      handler: function () {
        this.assignFieldValues();
      },
      deep: true,
    }
 
  },
  computed: {
    /**
     * Get user is normal or anonymous
     */
    isAnonymousUser() {
      if(this.userDetails.email.includes('@anonymous.com')){
        return true;
      }
      return false;
    },
    userDetails() {
      return this.$store.getters.getLoggedInUser;
    },
    availableYears() {
      let available = [];
      let currentYear = moment().format("YYYY");
      // Give 100 years down possibility
      for (let i = 1;; i++) {
        available.push(currentYear-i);
        if (i > 99)
           break;
      };
      return available;
    }, 
    
    vg_province() {
      return Env.provinces;
    },

    ...mapGetters({
      vg_selectedStore: "location/selected", 
      vg_businessProfile: "businessprofile/detail", 
      vg_getVisitorDetails: "getVisitorDetails",
    })
  },
 
  async mounted() {
    //await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    this.assignFieldValues();
    // Fetch user business's casl
    if(this.vg_businessProfile && this.vg_businessProfile.id){
      let res = await UserApis.getUserBusinessCASl(this.vg_businessProfile.id);
      if( (res.status != 200) && (this.userDetails.marketing_notification == true) ) {
        // Record not in table, mean subscribe notification
        this.casl = true;
        // pass casl on vbout
        VboutApis.addUserTag({
          email: this.userDetails.email,
          tagname: 'casl_opt_in',
        }, this.vg_selectedStore.id);
      } else {
        this.casl = false;
        // remove casl on vbout
         VboutApis.removeUserTag({
          email: this.userDetails.email,
          tagname: 'casl_opt_in',
        }, this.vg_selectedStore.id);
      }
    }
  },

  methods: {
    /**
     * Open change email modal
     */
    openChangeEmailModal() {
      bus.$emit('show-modal-change-email', true);
    },

    /**
     * Assign values
     */
    assignFieldValues() {
      this.form = {
        first_name: this.userDetails.first_name,
        last_name: this.userDetails.last_name,
        email: this.userDetails.email,
        phone: this.userDetails.phone,
        dob: this.userDetails.dob,
        marketing_notification: this.userDetails.marketing_notification ? true : false,
        email_notification: true,
      };
      if(this.userDetails.dob){
        //lets explode lets not work 
        let expDateIso = this.userDetails.dob.split('T');
        let day, month, year;
        if(expDateIso.length > 0){
          let expDate = expDateIso[0].split('-');
          if(expDate[0]){
            year = expDate[0];
          }
          if(expDate[1]){
            month = expDate[1];
          }
          if(expDate[2]){
            day = expDate[2];
          }
        }
        this.dob = {
          day: day,  //format moment(this.userDetails.dob).format('DD'),
          month: month,
          year: year,
        };
      }  else {
        this.dob = {
          day: '',  //format moment(this.userDetails.dob).format('DD'),
          month: '',
          year: '',
        };
      }
    },

    /*
      * Update profile detail
      */
    async updateProfile() {
       // valiudate dob first
      // this.dobError = '';
      // for(let key in this.dob){
      //   if(this.dob[key] == ''){
      //     this.dobError = "Please select full date.";
      //     break;
      //   }
      // }
      // Dob must not be empty to submit
      // if(this.dobError != ''){
      //   return false;
      // }
      if(this.dob.year && this.dob.month && this.dob.day) {
        let fulldate = moment(this.dob.year + '-' + this.dob.month + '-'+ this.dob.day).format("YYYY-MM-DD");
        if(fulldate == 'Invalid date'){
          this.va_snackbar({
            type: 'warning', 
            message: 'Sorry ' + this.dob.day + '-' + this.dob.month + '-'+ this.dob.year + ' is not a valid date.'
          });
          return false;
        }
        this.form.dob = fulldate;
        let todayDate = moment();
        var userInputdate = moment(this.form.dob);
        let userInputYearDiff = todayDate.diff(userInputdate, 'years');

        let provinceAgeBar = Env.userSignupAge;
        if(this.vg_getVisitorDetails.province){
          if(this.getProvinceAge(this.vg_getVisitorDetails.province)){
            provinceAgeBar = this.getProvinceAge(this.vg_getVisitorDetails.province);
          }
        }
  
        if(userInputYearDiff < provinceAgeBar){
          this.va_snackbar({
            type: 'warning', 
            message: 'You need to be over the age of '+ provinceAgeBar,
          });
          return;
        }
      }
      
      let validation = await Helpers.validateRefs(this, ['first_name', 'last_name',  'phone']);
      if( validation ) {
        this.va_spinner(true);
        let res = await UserApis.updateAccount({
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          // email: this.form.email,
          phone: this.form.phone,
          dob: this.form.dob,
          marketing_notification: this.casl ? true : false, //this.userDetails.marketing_notification ? true : (this.casl ? true : false),
          email_notification:true,
          business_id: this.vg_businessProfile.id
        });

        this.va_snackbar({
          type: res.status == 200 ? 'success' : 'warning',
          message: res.status == 200 ? res.data.msg : res.response.data.msg,
        });
        if(res.status == 200){
          this.$store.dispatch('SET_USER_DETAILS', res.data.payload);
          this.assignFieldValues();
          // We need to pass the data
          if(this.casl){
            // remove from table
            await UserApis.userBusinessCASlsubscribe(this.vg_businessProfile.id); 
          } else {
            // add to table
            await UserApis.userBusinessCASlunsubscribe(this.vg_businessProfile.id); 
          }

          // push data to vbout
          if(res.data.payload.email_verification_status && this.vg_selectedStore.id){
            // verified tag
            VboutApis.addUserTag({
              email: res.data.payload.email,
              tagname: 'verified',
            }, this.vg_selectedStore.id);
          }
          // casl_opt_in as marketing notification
          if(res.data.payload.marketing_notification){
            VboutApis.addUserTag({
              email: res.data.payload.email,
              tagname: 'casl_opt_in',
            }, this.vg_selectedStore.id);
          } else {
            VboutApis.removeUserTag({
              email: res.data.payload.email,
              tagname: 'casl_opt_in',
            }, this.vg_selectedStore.id);
          }
        }
        this.va_spinner(false);
      }
    },
 
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },

    /**
     * Trigger change password modal
     */
    changePassword() {
      bus.$emit('show-modal-change-password', true);
    },

    getProvinceAge(code) {
      if(!code){
        return '';
      }
      let provinceObj = _.find(this.vg_province, { value: code });
      if(provinceObj){
        return provinceObj.age;
      }
      return '';
    },

   ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>
<style scoped>
.pg-wrapper .control.is-animate .input{
  z-index: 8;
}
.pg-wrapper .edit-from .input{
    text-align: left;
    margin-top: 7px;
}
.day-month-year-picker p{
    font-size: 12px;
    padding: 8px 8px;
    padding-bottom: 0;
}
 .edit-account-dob select{
    height: 32px !important;
    padding-top: 0;
}
.control.select.is-full-width.pr-5 {
    padding-right: 25px;
    padding-left: 14px;
}
.edit-account .is-checkradio[type="checkbox"]+label:after{
  top: 4px;
}
</style>